import { render } from "./TaskSection.vue?vue&type=template&id=5c2f1496&scoped=true"
import script from "./TaskSection.vue?vue&type=script&lang=js"
export * from "./TaskSection.vue?vue&type=script&lang=js"

import "./TaskSection.vue?vue&type=style&index=0&id=5c2f1496&scoped=true&lang=css"

import exportComponent from "/home/runner/work/acp-portal-frontend/acp-portal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c2f1496"]])

export default __exports__